export default "__VITE_ASSET__Df73cvtg__"